import { clsx } from 'clsx'
import { Link } from 'react-router'

export type Crumb = { label: string; to?: string }

/** Eyebrow-styled trail: parents muted and linked, the current page in ink. */
export function Breadcrumb({ items, className }: { items: Crumb[]; className?: string }) {
  return (
    <nav aria-label="Breadcrumb" className={clsx('flex flex-wrap items-center gap-2 font-body text-eyebrow font-medium uppercase tracking-eyebrow', className)}>
      {items.map((c, i) => {
        const last = i === items.length - 1
        return (
          <span key={`${c.label}-${i}`} className="flex items-center gap-2">
            {i > 0 && <span aria-hidden="true" className="text-dim">/</span>}
            {c.to && !last ? (
              <Link to={c.to} className="text-dim underline-offset-4 hover:text-ink hover:underline">{c.label}</Link>
            ) : (
              <span className={last ? 'text-ink' : 'text-dim'} aria-current={last ? 'page' : undefined}>{c.label}</span>
            )}
          </span>
        )
      })}
    </nav>
  )
}
